export default function socialShareIcons() {
	if (/Mobi/.test(navigator.userAgent)) {
		$(document).on('touchstart',  '.social-modal-close-outer', function() {
			$('.socialsharing').toggleClass('active');
		});
		$(document).on('touchstart', '.social-share-trigger', function() {
				$('.socialsharing').toggleClass('active');
		});
	}else{
		$(document).on('click',  '.social-modal-close-outer', function() {
			$('.socialsharing').toggleClass('active');
		});
		$(document).on('click', '.social-share-trigger', function() {
				$('.socialsharing').toggleClass('active');
		});
	}
};